"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _webmidi = _interopRequireDefault(require("./lib/webmidi"));

var _setupHandlers = _interopRequireDefault(require("./lib/setupHandlers"));

var _removeHandlers = _interopRequireDefault(require("./lib/removeHandlers"));

var _utilities = require("./lib/utilities");

var _OSCSysex = _interopRequireDefault(require("./lib/OSCSysex"));

var address = _interopRequireWildcard(require("./lib/addresses"));

var _buildSendPreset = _interopRequireDefault(require("./lib/buildSendPreset"));

var _package = require("../package.json");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class MalletStation extends _eventemitter.default {
  constructor(access = {}, debug = false, oscDebug = false) {
    super();
    this.deviceName = typeof debug === 'string' ? debug : 'malletStation';
    this.deviceBootloaderName = `${this.deviceName} Bootloader`;
    this.version = _package.version;
    this.minimumRequiredFirmwareVersion = '1.0.88';
    this.connection = {
      input: {
        initial: false,
        previous: false,
        connected: false,
        open: false
      },
      output: {
        initial: false,
        previous: false,
        connected: false,
        open: false
      },
      bootloader: {
        initial: false,
        connected: false,
        open: false
      }
    };
    this._midi = access;
    this._debug = debug;
    this._oscDebug = oscDebug;
    this.initMIDI = false;
    this.bootloader = null;
    this.deviceMode = 'normal'; // set port connections

    this._midi.inputs.forEach(input => {
      if ((0, _utilities.isValidPort)(input.name, false)) {
        this.deviceName = input.name; // update OS-specific device name

        this.connection.input.initial = input.state === 'connected' ? true : false;
        this.connection.input.connected = input.state === 'connected' ? true : false;
        this.connection.input.open = input.connection === 'open' ? true : false;
      }
    });

    this._midi.outputs.forEach(output => {
      if ((0, _utilities.isValidPort)(output.name, false)) {
        this.connection.output.initial = output.state === 'connected' ? true : false;
        this.connection.output.connected = output.state === 'connected' ? true : false;
        this.connection.output.open = output.connection === 'open' ? true : false;
      } else if ((0, _utilities.isValidPort)(output.name, true)) {
        this.deviceBootloaderName = output.name; // update OS-specific device name

        this.connection.bootloader.initial = true;
        this.connection.bootloader.connected = output.state === 'connected' ? true : false;
        this.connection.bootloader.open = output.connection === 'open' ? true : false;
        this.emit('bootloader', true);
      }
    }); // intial initialisation


    if (this.connection.input.connected && this.connection.output.connected) {
      this._init(); // account for delay in editor initialization


      setTimeout(() => this.emit('connectprimary'), 100);
    } // setup handlers


    (0, _setupHandlers.default)(this);
  }

  _init() {
    if (this._debug) console.log('>> malletStation: Web MIDI init');
    this.initMIDI = true;
    this._ports = (0, _webmidi.default)(this._midi, this._debug);
    this.input = this._ports.getInput(this.deviceName);
    this.output = this._ports.getOutput(this.deviceName); // if device connected in bootloader mode, setup handlers after exiting bootloader mode

    if (this.connection.bootloader.initial && !this.connection.bootloader.connected) (0, _setupHandlers.default)(this); // update OS-specific bootloader name

    if (this.deviceName.includes('MIDI 1')) {
      // linux
      this.deviceBootloaderName = `${this.deviceBootloaderName} MIDI 1`;
    }
  }

  _buildMessage(path = '/', values = '', curve) {
    return (0, _OSCSysex.default)(this, path, values, curve);
  }

  _sendOSC(address, values) {
    const message = this._buildMessage(address, values);

    this.isConnected() ? this.send(message) : () => console.warn('>> midi: cannot send to device, try reconnecting');
  }

  send(message) {
    // send to device edit buffer
    this.isConnected() ? this.output.send(message) : () => console.warn('>> midi: cannot send to device, try reconnecting');
  }

  setParam(param = '', values = '') {
    if (this._debug) console.log('>> malletStation setParam', param, values);

    const basePath = (0, _utilities.isGlobalParam)(param) ? '/g' : '/p',
          message = this._buildMessage(`${basePath}/w/${param}`, values);

    this.send(message);
  }

  getParam(param = '', values = '') {
    const basePath = (0, _utilities.isGlobalParam)(param) ? '/g' : '/p',
          message = this._buildMessage(`${basePath}/r/${param}`, values);

    this.send(message);
  }

  enterBootloader() {
    const message = this._buildMessage(address.BOOTLOADER);

    this.send(message); // start polling to connect to bootloader

    (0, _utilities.pollPort)(this, this.deviceBootloaderName, 'output').then(port => {
      this.bootloader = port;
      this.emit('bootloaderready');
      Promise.all([(0, _utilities.pollPort)(this, this.deviceName, 'input'), (0, _utilities.pollPort)(this, this.deviceName, 'output')]).then(() => this.emit('firmwareupdatecomplete'));
    });
  }

  reset(mode = 'all', returnTimout = 20) {
    let modes = mode.split(',').map(m => m.trim());
    modes.forEach(m => {
      if (m === 'globals' || m === 'all') this._sendOSC(address.REINITGLOBALS);
      if (m === 'presets' || m === 'all') this._sendOSC(address.REINITPRESETS);
      if (m === 'curves' || m === 'all') this._sendOSC(address.REINITCURVES);
      if (m === 'mults' || m === 'all') this._sendOSC(address.REINITMULTS);
      if (m === 'averages') this._sendOSC(address.REINITAVERAGES);
    });

    if (mode === 'calibration') {
      if (this.deviceMode !== 'calibration' || this.deviceMode !== 2) {
        const currentMode = this.deviceMode;
        this.setDeviceMode('calibration');

        this._sendOSC(address.REINITCALIBRATION);

        setTimeout(() => this.setDeviceMode(currentMode), returnTimout);
      } else {
        this._sendOSC(address.REINITCALIBRATION);
      }
    }
  } // this enables device <--> editor sync


  editorConnect() {
    const message = this._buildMessage(address.CONNECT);

    this.send(message);
  }

  editorDisconnect() {
    const message = this._buildMessage(address.DISCONNECT);

    this.send(message);
  }

  isConnected() {
    return this.connection.input.connected && this.connection.output.connected ? true : false;
  }

  getFirmwareVersion() {
    const message = this._buildMessage(address.VERSIONS);

    this.send(message);
  }

  getButtonMode() {
    this.getParam('buttonPresetMode');
  }

  getCrosstalkVelocity() {
    this.getParam('crosstalkVelocityScale');
  }

  getCrosstalkTimeWindow() {
    this.getParam('crosstalkTimeWindow');
  }

  getPreset(presetIndex = 0) {
    const message = this._buildMessage(address.GETPRESET, presetIndex);

    this.send(message);
  }

  getUserCurve(curveIndex) {
    const message = this._buildMessage(address.GETUSERCURVE, curveIndex);

    this.send(message);
  }

  loadPreset(presetIndex) {
    // if on-device preset : load flash preset to the edit buffer [1-4]
    const message = this._buildMessage(address.LOADPRESET, presetIndex);

    this.send(message);
  }

  savePreset(presetIndex = 1) {
    // save edit buffer to flash [1-4]
    // final saving of presets
    const message = this._buildMessage(address.SAVEPRESET, presetIndex);

    this.send(message);
  }

  saveUserCurve(curveIndex = 0, curve) {
    const message = this._buildMessage(address.SAVEUSERCURVE, curveIndex, curve);

    this.send(message);
  }

  saveGlobals() {
    /* save the RAM globals to flash */
    const message = this._buildMessage(address.SAVEGLOBALS, '0');

    this.send(message);
  }

  setButtonMode(mode, save = true) {
    this.setParam('buttonPresetMode', `${mode}`);
    if (save) this.saveGlobals();
  }

  setCrosstalkVelocity(value, save = true) {
    this.setParam('crosstalkVelocityScale', `${value}`);
    if (save) this.saveGlobals();
  }

  setCrosstalkTimeWindow(value, save = true) {
    this.setParam('crosstalkTimeWindow', `${value}`);
    if (save) this.saveGlobals();
  }

  sendPreset(presetObject) {
    // on preset select : editor to edit buffer
    if (this._debug) console.log('>> malletStation sendPreset', presetObject);
    const messages = (0, _buildSendPreset.default)(presetObject, true); // loop and send to edit buffer

    messages.forEach(messageObject => {
      this.setParam(messageObject.param, messageObject.values);
    });
  } // Learn Mode


  setDeviceMode(mode = 'normal', reloadGlobals = false) {
    const modes = ["normal", "tether", "calibration", "pcbtest", "learn"],
          deviceMode = typeof mode === 'string' ? modes.indexOf(mode) : mode;

    this._sendOSC(address.DEVICEMODE, deviceMode);

    this.deviceMode = mode;
  }

  getCalibration(returnTimout = 20) {
    if (this.deviceMode !== 'calibration' || this.deviceMode !== 2) {
      const currentMode = this.deviceMode;
      this.setDeviceMode('calibration');

      this._sendOSC(address.GETCALIBRATION);

      setTimeout(() => this.setDeviceMode(currentMode), returnTimout);
    } else {
      this._sendOSC(address.GETCALIBRATION);
    }
  }

  setCalibration(blob, returnTimout = 20) {
    const BLOB = new Uint8Array(blob);

    if (this.deviceMode !== 'calibration' || this.deviceMode !== 2) {
      const currentMode = this.deviceMode;
      this.setDeviceMode('calibration');

      this._sendOSC(address.SETCALIBRATION, BLOB);

      setTimeout(() => this.setDeviceMode(currentMode), ~~returnTimout);
    } else {
      this._sendOSC(address.SETCALIBRATION, BLOB);
    }
  }

  getCalibrationGain() {
    this.getParam('calibrationGain');
  }

  setCalibrationGain(gain, save = true) {
    this.setParam('calibrationGain', `${gain}`);
    if (save) this.saveGlobals();
  }

  getBarTares() {
    this._sendOSC(address.GETTARES);
  }

  getBarGains() {
    this.getParam('barGains');
  }

  getBarGain(bar = '0') {
    this.getParam('barGain', `${bar}`);
  }

  setBarGain(bar = '0', gain = '1.00', save = true) {
    this.setParam('barGain', `${bar},${gain}`);
    if (save) this.saveGlobals();
  }

  getBarAverages(mode = 'low') {
    // mode = low | high
    this.getParam(`barAvg${(0, _utilities.titleize)(mode)}s`);
  }

  getBarAverage(mode = 'low', bar = '0') {
    // mode = low | high
    this.getParam(`barAvg${(0, _utilities.titleize)(mode)}`, `${bar}`);
  }

  setBarAverage(mode = 'low', barIndex = '0', average = '0', save = true) {
    // mode = low | high
    this.setParam(`barAvg${(0, _utilities.titleize)(mode)}`, `${barIndex}, ${average}`);
    if (save) this.saveGlobals();
  }

  getNegativeOffsets() {
    console.warn('>> malletStation API: this method is deprecated.');
  }

  getNegativeOffset(barIndex = '0') {
    console.warn('>> malletStation API: this method is deprecated.');
  }

  setNegativeOffset(barIndex = '0', offset = '0', save = true) {
    console.warn('>> malletStation API: this method is deprecated.');
  }

  getBarThresholds(mode = 'down') {
    this.getParam(`bar${(0, _utilities.titleize)(mode)}Thresholds`);
  }

  setBarThreshold(mode = 'down', barIndex = '0', threshold = '0', save = true) {
    this.setParam(`bar${(0, _utilities.titleize)(mode)}Threshold`, `${barIndex}, ${threshold}`);
    if (save) this.saveGlobals();
  }

  getBarMults(mode = 'low') {
    this.getParam(`bar${(0, _utilities.titleize)(mode)}Mults`);
  }

  getBarMult(mode = 'low', bar = '0') {
    this.getParam(`bar${(0, _utilities.titleize)(mode)}Mult`, `${bar}`);
  }

  setBarMult(mode = 'low', barIndex = '0', mult = '1.00', save = true) {
    this.setParam(`bar${(0, _utilities.titleize)(mode)}Mult`, `${barIndex}, ${mult}`);
    if (save) this.saveGlobals();
  }

  getGlobalThresholdMult() {
    this.getParam(`thresholdMult`);
  }

  setGlobalThresholdMult(mult = '1.00', save = true) {
    this.setParam(`thresholdMult`, `${mult}`);
    if (save) this.saveGlobals();
  }

}

exports.default = MalletStation;